export const iconFontAwesomeHumanitarianSnowflake = (
	<i className="fa-solid fa-snowflake"></i>
);
